import type { FC } from "react";

import { Background } from "~/shared/ui-kit";
import { Flex } from "~/shared/ui-kit/flex/Flex";
import { Title } from "~/shared/ui-kit/title/Title";
import { Typography } from "~/shared/ui-kit/typography/Typography";

type ColumnCardProps = {
  text: string;
  index: number;
};

export const ColumnCard: FC<ColumnCardProps> = ({ text, index }) => {
  return (
    <Background
      bgValue="linear-gradient(360deg, #4E16A04D -15.91%, #6A17BD00 142.61%)"
      className="rounded-2xl"
    >
      <Flex
        align="center"
        flexDirection="row"
        justify="flex-start"
        gap={24}
        d={{ gap: 32 }}
        className="min-w-[312px] min-h-[128px] max-h-[176px] pl-8 lg:pl-12 lg:py-12 lg:max-w-[400px] xl:min-w-[400px]"
      >
        <Typography
          as="span"
          weight="bold"
          className="!text-[96px] !leading-[134px] bg-gradient-to-r from-[#FB6D17] via-[#F4964B] to-[#FABA8E] bg-clip-text text-transparent max-w-[128px]"
        >
          {index < 10 ? `0${index}` : index}
        </Typography>
        <div>
          <Title
            as="h4"
            size="small"
            weight="bold"
            md={{ weight: "bold" }}
            className="lg:leading-8 pb-2"
          >
            {text.split(" ")[0]}
          </Title>
          <Typography size="medium" d={{ size: "large" }}>
            {text.split(" ").slice(1).join(" ")}
          </Typography>
        </div>
      </Flex>
    </Background>
  );
};
